<template>
    <ion-chip class="file" outline color="primary" @click="openFilePopover" :title="file.name">
        <ion-label class="ion-text-nowrap">
            <ion-icon ios='attach' md="attach" slot="start"></ion-icon>
            <span>{{ file.short_name }}</span>
            <ion-badge slot="end" v-if="!$root.isMobileOrSmall">{{ file.readable_size }}</ion-badge>
        </ion-label>
    </ion-chip>
</template>

<script>
    import FilePopover from "./nav/FilePopover";

    export default {
        name: "File",
        props: {
            file: {type: Object},
        },
        methods: {
            async openFilePopover(event) {
                const popover = await this.$ionic.popoverController
                    .create({
                        component: FilePopover,
                        componentProps: {
                            parent: this,
                            propsData: {
                                file: this.file,
                            },
                        },
                        cssClass: ['file-popover'],
                        event,
                    });

                await popover.present();
            }
        },
    }
</script>

<style scoped lang="scss">
    .file {
        max-width: 98%;
        flex: 0 0 auto;

        ion-icon {
            margin-right: 3px;
            font-size: 18px;
            min-width: 16px;
        }

        ion-label {
            display: flex;
            align-items: center;
        }

        ion-badge {
            margin-left: 8px;
            font-size: 11px;
        }
    }
</style>
